import React from 'react'
import './Service.css';

const Service = () => {
  return (
    <div>
      <section id="service">
        <h1 id='h12'>Our Services</h1>
        <div id='div1'className='div'><span className='span'>Weddings</span></div>
        <div id='div2'className='div'><span className='span'>Parties</span></div>
        <div id='div3'className='div'><span className='span'>Birthdays</span></div>
        <div id='div4'className='div'><span className='span'>Events</span></div>
        <div id='div5'className='div'><span className='span'>Custom</span></div>
      </section>
    </div>
  );
}

export default Service